import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";


export default function ButtonGroupObject(props) {
const {items ,value,setValue, width=100} = props

    return (<ToggleButtonGroup style={{height: 40, width: 50}} value={value} onChange={(e, val) => {
       
        setValue(val)
    }
    }  exclusive>
        {items.map(i => <ToggleButton style={{width}} key={i._id} value={i._id}>{i.name}</ToggleButton>)}
    </ToggleButtonGroup>)
}